<template>
  <FormCadastro
    :title="
      (fluxo.ID_FLUXO_DE_CAIXA ? 'Título - ' + fluxo.ID_FLUXO_DE_CAIXA + ' / ' + fluxo.EMITENTE_RESUMIDO : 'Informações do título')
    "
    :loading="loading"
    @voltar="voltar"
    @salvar="salvar"
    :exibirBotoes="exibirBotoes"
    :dataInclusao="fluxo.DATA_INCLUSAO"
    :usuarioInclusao="fluxo.USUARIO_INCLUSAO"
    :dataAlteracao="fluxo.DATA_ALTERACAO"
    :usuarioAlteracao="fluxo.USUARIO"
    :botoesMenu="botoesMenu"
    @botoesMenu="clickMenu"
  >
    <template v-slot:badge>
      <b-badge pill :variant="(fluxo.PAGAR_RECEBER == 'R') ? 'primary' : 'danger'" style="margin-right: 5px; font-size: 10px;">
        {{ statusTitulo }}
      </b-badge>
      <b-badge pill variant="info" v-if="temRateios" style="margin-right: 5px; font-size: 10px;">
        RATEIOS
      </b-badge>
    </template>
    <BotoesEnvio
      ref="botoesEnvio"
      :pagRec="fluxo.PAGAR_RECEBER"
      :pagamento="fluxo.DATA_PAGAMENTO"
      :idEmitente="fluxo.ID_EMITENTE"
      :idFluxoDeCaixa="fluxo.ID_FLUXO_DE_CAIXA"
      v-if="fluxo.ID_FLUXO_DE_CAIXA"
      :telefones="telefones"
    />
    <b-form-group>
      <SearchBoxEmpresa ref="empresa" v-model="fluxo.ID_EMPRESA" />
    </b-form-group>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="">
          <b-form-radio 
            v-if="fluxo.PAGAR_RECEBER == 'R'" 
            v-model="fluxo.PAGAR_RECEBER"
            name="pag-rec"
            value="R"
            disabled
          >
            Receber
          </b-form-radio>
          <b-form-radio 
            v-if="fluxo.PAGAR_RECEBER == 'P'" 
            v-model="fluxo.PAGAR_RECEBER"
            name="pag-rec"
            value="P"
            disabled
          >
            Pagar
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="">
          <b-form-radio v-model="fluxo.STATUS" name="status-compromisso" value="C">
            Compromisso
          </b-form-radio>
          <b-form-radio v-model="fluxo.STATUS" name="status-compromisso" value="P">
            Previsão
          </b-form-radio>
          <b-form-radio v-model="fluxo.STATUS" name="status-compromisso" value="R">
            Provisão
          </b-form-radio>
        </b-form-group>
      </div>
      <div class="col-md-4">
        <b-form-group label="">
          <b-form-radio v-model="fluxo.STAT" name="status-aprovado" value="A">
            Aprovado
          </b-form-radio>
          <b-form-radio v-model="fluxo.STAT" name="status-liberado" value="L">
            Liberado
          </b-form-radio>
          <b-form-radio v-model="fluxo.STAT" name="status-cancelado" value="O">
            Bloqueado
          </b-form-radio>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Emissão:">
          <b-form-input
            type="date"
            v-model="fluxo.DATA_EMISSAO"
            placeholder="Emissão"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Competência:">
          <b-form-input
            type="date"
            v-model="fluxo.COMPETENCIA"
            placeholder="Competência"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <b-form-group label="Exercício:">
      <b-form-input
        type="text"
        v-model="fluxo.EXERCICIO"
        placeholder="Exercício"
        maxlength="8"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="">
      <b-form-checkbox
        id="liquidacaoTotal"
        v-model="fluxo.LIQUIDACAO_TOTAL"
        name="liquidacaoTotal"
        :value="true"
        :unchecked-value="false"
      >
        Liquidação total
      </b-form-checkbox>
    </b-form-group>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Vencimento:">
          <b-form-input
            type="date"
            v-model="fluxo.DATA_VENCIMENTO"
            @change="mesmoVencimento"
            placeholder="Vencimento"
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group label="Vencimento Original:">
          <b-form-input
            type="date"
            v-model="fluxo.DATA_VENCIMENTO_ORIGINAL"
            placeholder="Vencimento Original"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <InputValor @change="mesmoValor" v-model="fluxo.VALOR" ref="valor" />
      </div>
      <div class="col-md-6">
        <InputValor v-model="fluxo.VALOR_ORIGINAL" ref="valorOriginal" label="Valor Original" />
      </div>
    </div>
    <div class="row" v-if="fluxo.DATA_PAGAMENTO">
      <div class="col-md-6">
        <b-form-group label="Data Pagamento:">
          <b-form-input
            type="date"
            v-model="fluxo.DATA_PAGAMENTO"
            placeholder="Data Pagamento"
            disabled
          ></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-6">
        <InputValor v-model="fluxo.VALOR_PAGO" ref="valorPago" label="Valor Pago" :disabled="true" />
      </div>
    </div>
    <b-form-group>
      <SearchBoxDefault 
        ref="emitente" 
        v-model="fluxo.ID_EMITENTE" 
        label="Emitente:" 
        placeholder="Busca Emitente por Nome, CPF/CNPJ, Código ou Data de nascimento" 
        funcaoBuscar="getEmitentes" 
        :incluir="true"
        :alterar="true"
        @botaoInclusao="incluirEmitente"
        @botaoAlteracao="alterarEmitente"
      />
    </b-form-group>
    <b-form-group>
      <SearchBoxPlanoFinanceiro
        ref="planoFinanceiro"
        v-model="fluxo.ID_PLANO_FINANCEIRO"
        :pagarReceber="(fluxo.PAGAR_RECEBER == 'R' ? 'C' : 'D')"
      />
    </b-form-group>
    <b-form-group label="Código de Barras:" v-if="fluxo.PAGAR_RECEBER == 'P'">
      <b-form-input
        type="number"
        v-model="fluxo.DOCUMENTO_CODIGO_BARRAS"
        placeholder="Código de Barras"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Linha digitável:" v-if="fluxo.PAGAR_RECEBER == 'P'">
      <b-form-input
        type="text"
        v-model="fluxo.DOCUMENTO_LINHA_DIGITAVEL"
        placeholder="Linha Digitável"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Histórico:">
      <b-form-input
        type="text"
        v-model="fluxo.HISTORICO"
        placeholder="Histórico"
      ></b-form-input>
    </b-form-group>
    <b-form-group label="Tipo Título:">
      <b-form-select
        v-model="fluxo.DOCUMENTO_TIPO"
        :options="tiposTitulo"
      ></b-form-select>
    </b-form-group>
    <b-form-group label="Observação:">
      <b-form-input
        type="text"
        v-model="fluxo.OBSERVACAO"
        placeholder="Observação"
      ></b-form-input>
    </b-form-group>
    <b-form-group>
      <SearchBoxPortador ref="portador" v-model="fluxo.ID_PORTADOR" />
    </b-form-group>
    <div class="row">
      <div class="col-md-6">
        <b-form-group>
          <SearchBoxProjeto ref="projeto" v-model="fluxo.ID_PROJETO" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group>
          <SearchBoxCentroResponsabilidade
            ref="centroDeResponsabilidade"
            v-model="fluxo.ID_CENTRO_RESPONSABILIDADE"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group>
          <SearchBoxTipoMulta ref="tipoMulta" v-model="fluxo.ID_TIPO_DE_MULTA" />
        </b-form-group>
      </div>
      <div class="col-md-6">
        <b-form-group>
          <SearchBoxNaturezaOperacao
            ref="naturezaOperacao"
            v-model="fluxo.ID_NATUREZA_OPERACAO"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row" v-if="!$route.params.id">
      <div class="col-md-12">
        <h3 class="font-size-lg text-dark font-weight-bold mb-6" style="margin-bottom: 0px !important;">
          <b-form-checkbox
            v-model="tituloRecorrente"
            name="tituloRecorrente"
            :value="true"
            :unchecked-value="false"
          >
            Título Recorrente?
          </b-form-checkbox>
        </h3>
      </div>
    </div>
    <div v-if="tituloRecorrente">
      <div class="row" style="margin-top: 20px;">
        <div class="col-md-4">
          <b-form-group label="Descrição Contrato:">
            <b-form-input
              type="text"
              v-model="transacao.DESCRICAO"
              placeholder="Descrição Contrato"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Data Início:">
            <b-form-input
              type="date"
              v-model="transacao.DATA_INICIO"
              placeholder="Data Início"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Data Término:">
            <b-form-input
              type="date"
              v-model="transacao.DATA_TERMINO"
              placeholder="Data Término"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Tipo do Vencimento:">
            <b-form-radio-group
              v-model="transacao.TIPO_VENCIMENTO"
              :options="opcoesTiposVencimento"
              name="radio-inline-tipovencimento"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-group label="Vencimento em dia útil:">
            <b-form-checkbox
              v-model="transacao.VENCIMENTO_EM_DIA_UTIL"
              name="checkbox-vencimentodiautil"
              value="1"
              unchecked-value="0"
            >
              Sim
            </b-form-checkbox>
          </b-form-group>
          <b-form-group label="Opções">
            <b-form-radio-group
              v-model="transacao.DIA_UTIL_ANTES_OU_DEPOIS"
              :options="opcoesDiaUtilAntesDepois"
              name="radio-inline-diautilantesdepois"
              stacked
            ></b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group label="Tipo Exercício:" style="">
            <b-form-radio-group
              v-model="transacao.TIPO_EXERCICIO"
              :options="opcoesTipoExercicio"
              name="radio-inline-tipoexercicio"
              stacked
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <b-form-checkbox
            v-model="transacao.DOCUMENTO_FISCAL"
            name="checkbox-docfiscalservico"
            value="1"
            unchecked-value="0"
          >
            Documento Fiscal de Serviço
          </b-form-checkbox>
          <b-form-checkbox
            v-model="transacao.ABATE_IMPOSTO"
            name="checkbox-abateimposto"
            value="1"
            unchecked-value="0"
          >
            Abate Imposto
          </b-form-checkbox>
          <b-form-checkbox
            v-model="transacao.E_PROVISAO"
            name="checkbox-provisao"
            value="1"
            unchecked-value="0"
          >
            Provisão
          </b-form-checkbox>
        </div>
        <div class="col-md-6">
          <b-form-group label="Local Contrato:">
            <b-form-input
              type="text"
              v-model="transacao.CONTRATO_LOCALIZACAO"
              placeholder="Local Contrato"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
    </div>
    <EmitenteTelefones
      :telefones="telefones"
      :loading="loadingTelefones"
      :pagRec="fluxo.PAGAR_RECEBER"
    />
    <GED
      ref="ged"
      :idEmitente="fluxo.ID_EMITENTE"
      :idFluxoDeCaixa="fluxo.ID_FLUXO_DE_CAIXA"
      v-if="fluxo.ID_FLUXO_DE_CAIXA"
    />
    <Rateio ref="rateio" :idFluxoDeCaixa="fluxo.ID_FLUXO_DE_CAIXA" :valor="fluxo.VALOR" @saiuModal="saiuModal" />
    <Quitacao 
      ref="quitacao" 
      :idFluxoDeCaixa="fluxo.ID_FLUXO_DE_CAIXA" 
      :idPortador="fluxo.ID_PORTADOR" 
      :valor="fluxo.VALOR" 
      :valorPago="fluxo.VALOR_PAGO" 
      @salvar="buscarFluxo" 
    />
    <BoletosFluxo
      :boletos="boletos"
      :loading="loadingBoletos"
      :pagRec="fluxo.PAGAR_RECEBER"
    />
    <NFsFluxo
      :nfs="nfs"
      :loading="loadingNFs"
      :pagRec="fluxo.PAGAR_RECEBER"
    />
  </FormCadastro>
</template>

<style lang="scss" scoped></style>

<script>
import { mapGetters, mapActions } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import SearchBoxDefault from "@/../../components-spirit/SearchBox/SearchBoxDefault.vue";
import SearchBoxEmpresa from "@/../../components-spirit/SearchBox/SearchBoxEmpresa.vue";
import SearchBoxPlanoFinanceiro from "@/../../components-spirit/SearchBox/SearchBoxPlanoFinanceiro.vue";
import SearchBoxProjeto from "@/../../components-spirit/SearchBox/SearchBoxProjeto.vue";
import SearchBoxPortador from "@/../../components-spirit/SearchBox/SearchBoxPortador.vue";
import SearchBoxCentroResponsabilidade from "@/../../components-spirit/SearchBox/SearchBoxCentroResponsabilidade.vue";
import SearchBoxNaturezaOperacao from "@/../../components-spirit/SearchBox/SearchBoxNaturezaOperacao.vue";
import SearchBoxTipoMulta from "@/../../components-spirit/SearchBox/SearchBoxTipoMulta.vue";

import InputValor from "@/../../components-spirit/Inputs/InputValor.vue";

import FormCadastro from "@/../../components-spirit/FormCadastro/FormCadastro.vue";

import GED from "@/view/pages/GED.vue";
import Rateio from "@/view/pages/Rateio.vue";
import Quitacao from "@/view/pages/Quitacao.vue";
import BotoesEnvio from "@/view/pages/BotoesEnvio.vue";
import EmitenteTelefones from "@/view/pages/EmitenteTelefones.vue";

import BoletosFluxo from "@/view/pages/BoletosFluxo.vue";
import NFsFluxo from "@/view/pages/NFsFluxo.vue";

import moment from "moment";
import Swal from "sweetalert2";

export default {
  name: "IncluirVenda",
  data() {
    return {
      fluxoVazio: {},
      fluxo: {
        ID_FLUXO_DE_CAIXA: "",
        PAGAR_RECEBER: "R",
        STATUS: "C",
        STAT: "A",
        ID_EMITENTE: 0,
        EMITENTE: "",
        EMITENTE_RESUMIDO: "",
        ID_PLANO_FINANCEIRO: 0,
        ID_EMPRESA: 0,
        DATA_VENCIMENTO: "",
        DATA_VENCIMENTO_ORIGINAL: "",
        DATA_PAGAMENTO: "",
        VALOR: "",
        VALOR_ORIGINAL: "",
        VALOR_PAGO: "",
        LIQUIDACAO_TOTAL: true,
        DOCUMENTO_CODIGO_BARRAS: "",
        DOCUMENTO_LINHA_DIGITAVEL: "",
        DATA_EMISSAO: "",
        COMPETENCIA: "",
        EXERCICIO: "",
        HISTORICO: "",
        DOCUMENTO_TIPO: "",
        OBSERVACAO: "",
        ID_PROJETO: 0,
        ID_PORTADOR: 0,
        ID_TIPO_DE_MULTA: 0,
        ID_NATUREZA_OPERACAO: 0,
        ID_CENTRO_RESPONSABILIDADE: 0,
        USUARIO_INCLUSAO: "",
        DATA_INCLUSAO: "",
        USUARIO: "",
        DATA_ALTERACAO: ""
      },
      tiposTitulo: [
        { value: "", text: "Selecione o tipo do título" },
        { value: "Documento", text: "Documento" },
        { value: "Duplicata", text: "Duplicata" },
        { value: "Deb. Aut.", text: "Deb. Aut." }
      ],
      loading: false,
      exibirBotoes: true,
      botoesMenu: [
        {
          title: "Enviar Cobrança via E-mail",
          evento: "enviarEmailCobranca",
          exibir: false
        },
        {
          title: "Enviar Cobrança via SMS",
          evento: "enviarSMSCobranca",
          exibir: false
        },
        {
          title: "Enviar Cobrança via WhatsApp",
          evento: "enviarWhatsAppCobranca",
          exibir: false
        },
        {
          title: "Rateio",
          evento: "efetuarRateio",
          exibir: false
        },
        {
          title: "Pagar Paylogos",
          evento: "pagarPaylogos",
          exibir: false
        },
        {
          title: "Quitação Registrada",
          evento: "quitar",
          exibir: false
        }
      ],
      telefones: [],
      boletos: [],
      nfs: [],
      loadingTelefones: false,
      loadingBoletos: false,
      loadingNFs: false,
      temRateios: false,
      tituloRecorrente: false,
      transacao: {
        DESCRICAO: "",
        DATA_INICIO: "",
        DATA_TERMINO: "",
        TIPO_VENCIMENTO: "U",
        VENCIMENTO_EM_DIA_UTIL: "0",
        DIA_UTIL_ANTES_OU_DEPOIS: "0",
        TIPO_EXERCICIO: "P",
        DOCUMENTO_FISCAL: "0",
        ABATE_IMPOSTO: "0",
        E_PROVISAO: "0",
        CONTRATO_LOCALIZACAO: ""
      },
      opcoesTiposVencimento: [
        { text: "Semanal", value: "S" },
        { text: "Quinzenal", value: "Q" },
        { text: "Mensal dia fixo", value: "M" },
        { text: "Mensal dia útil", value: "U" },
        { text: "Anual", value: "A" },
        { text: "Cobrança Registrada", value: "C" }
      ],
      opcoesDiaUtilAntesDepois: [
        { text: "Dia Anterior", value: "D" },
        { text: "Próximo dia", value: "P" }
      ],
      opcoesTipoExercicio: [
        { text: "Período Atual", value: "P" },
        { text: "Período Anterior", value: "A" },
        { text: "Configurado", value: "C" }
      ]
    };
  },
  components: {
    SearchBoxDefault,
    SearchBoxEmpresa,
    SearchBoxPlanoFinanceiro,
    SearchBoxProjeto,
    SearchBoxPortador,
    SearchBoxCentroResponsabilidade,
    SearchBoxNaturezaOperacao,
    SearchBoxTipoMulta,
    InputValor,
    FormCadastro,
    GED,
    Rateio,
    Quitacao,
    BotoesEnvio,
    EmitenteTelefones,
    BoletosFluxo,
    NFsFluxo
  },
  async mounted() {
    Object.keys(this.fluxo).forEach((item) => this.fluxoVazio[item] = this.fluxo[item]);
    if (this.$route.params.id) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Alterar título" }]);

      this.buscarFluxo();
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Incluir título" }]);
      this.fluxo.PAGAR_RECEBER = this.fgModoPR;
      this.fluxo.DATA_VENCIMENTO = moment().format("YYYY-MM-DD");
      this.fluxo.DATA_VENCIMENTO_ORIGINAL = moment().format("YYYY-MM-DD");
      this.fluxo.DATA_EMISSAO = moment().format("YYYY-MM-DD");
      this.fluxo.EXERCICIO = moment().format("MM/YYYY");
    }

    if(Object.keys(this.fluxoInclusaoAlteracaoBackup).length !== 0) {
      let e = await Swal.fire({
        title: "",
        text: "Deseja recuperar as informações que estavam preenchidas?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (e.value) {
        this.atribuirObj(this.fluxoInclusaoAlteracaoBackup);
        this.atualizarFluxoInclusaoAlteracaoBackup({});
      } else {
        this.atualizarFluxoInclusaoAlteracaoBackup({});
      }
    }
  },
  computed: {
    ...mapGetters(["fgModoPR", "fluxoInclusaoAlteracaoBackup"]),
    statusTitulo() {
      if(this.fluxo.PAGAR_RECEBER == 'R') {
        if(this.fluxo.DATA_PAGAMENTO) {
          return 'RECEBIDO';
        } else {
          return 'A RECEBER';
        }
      } else {
        if(this.fluxo.DATA_PAGAMENTO) {
          return 'PAGO';
        } else {
          return 'A PAGAR';
        }
      }
    }
  },
  methods: {
    ...mapActions([
      "updateFluxoDeCaixa",
      "getFluxoDeCaixa",
      "getEmitenteTelefone",
      "getRateios",
      "getBoletosFluxo",
      "getNFsFluxo",
      "atualizarFluxoInclusaoAlteracaoBackup"
    ]),
    async buscarFluxo() {
      this.loading = true;

      let fluxoDeCaixa = await this.getFluxoDeCaixa(this.$route.params.id);
      this.atribuirObj(fluxoDeCaixa);

      this.buscarTelefonesEmitente();
      this.buscarBoletosFluxo();
      this.buscarNFsFluxo();

      let rateios = await this.getRateios(this.$route.params.id);

      if(rateios.length) {
        this.temRateios = true;
      } else {
        this.temRateios = false;
      }

      this.loading = false;
    },
    formataValores() {
      this.$refs.valor.formataValor();

      if (this.fluxo.VALOR_ORIGINAL) {
        this.$refs.valorOriginal.formataValor();
      } else {
        this.mesmoValor();
      }

      if (this.fluxo.VALOR_PAGO) {
        this.$refs.valorPago.formataValor();
      }
    },
    mesmoVencimento() {
      this.fluxo.DATA_VENCIMENTO_ORIGINAL = this.fluxo.DATA_VENCIMENTO;
      this.$refs.valor.focus();
    },
    mesmoValor() {
      this.fluxo.VALOR_ORIGINAL = this.fluxo.VALOR;
    },
    atribuirObj(obj) {
      if (obj.ID_FLUXO_DE_CAIXA) {
        this.fluxo.ID_FLUXO_DE_CAIXA = obj.ID_FLUXO_DE_CAIXA;

        if(obj.PAGAR_RECEBER == 'R') {
          this.botoesMenu.forEach((item, index) => (index == 3 || index == 4) ? item.exibir = false : item.exibir = true);
        } else {
          this.botoesMenu.forEach((item, index) => (index == 3 || index == 4 || index == 5) ? item.exibir = true : item.exibir = false);
        }
      }
      if (obj.PAGAR_RECEBER) {
        this.fluxo.PAGAR_RECEBER = obj.PAGAR_RECEBER;
      }
      if (obj.STATUS) {
        this.fluxo.STATUS = obj.STATUS;
      }
      if (obj.STAT) {
        this.fluxo.STAT = obj.STAT;
      }
      if (obj.ID_EMITENTE) {
        this.fluxo.ID_EMITENTE = obj.ID_EMITENTE;
        this.fluxo.EMITENTE = obj.EMITENTE;
        if(obj.EMITENTE_RESUMIDO) {
          this.fluxo.EMITENTE_RESUMIDO = obj.EMITENTE_RESUMIDO;
        }
        this.$refs.emitente.selecionar({
          ID: obj.ID_EMITENTE,
          DESCRICAO: obj.EMITENTE
        });
      }
      if (obj.ID_PLANO_FINANCEIRO) {
        this.fluxo.ID_PLANO_FINANCEIRO = obj.ID_PLANO_FINANCEIRO;
        this.$refs.planoFinanceiro.selecionar({
          ID: obj.ID_PLANO_FINANCEIRO,
          DESCRICAO: obj.PLANO_FINANCEIRO
        });
      }
      if (obj.ID_EMPRESA) {
        this.fluxo.ID_EMPRESA = obj.ID_EMPRESA;

        this.$refs.empresa.selecionar({
          ID: obj.ID_EMPRESA,
          DESCRICAO: obj.EMPRESA
        });
      }
      if (obj.DATA_VENCIMENTO) {
        this.fluxo.DATA_VENCIMENTO = moment(
          obj.DATA_VENCIMENTO,
          "YYYYMMDD[T]HHmmss"
        ).format("YYYY-MM-DD");
      }
      if (obj.DATA_VENCIMENTO_ORIGINAL) {
        this.fluxo.DATA_VENCIMENTO_ORIGINAL = moment(
          obj.DATA_VENCIMENTO_ORIGINAL,
          "YYYYMMDD[T]HHmmss"
        ).format("YYYY-MM-DD");
      }
      if (obj.DATA_PAGAMENTO) {
        this.fluxo.DATA_PAGAMENTO = moment(
          obj.DATA_PAGAMENTO,
          "YYYYMMDD[T]HHmmss"
        ).format("YYYY-MM-DD");

        this.botoesMenu.forEach((item, index) => (index == 0 || index == 1 || index == 2 || index == 4 || index == 5) ? item.exibir = false : item.exibir = true);
      }
      if (obj.VALOR) {
        this.fluxo.VALOR = obj.VALOR;
      }
      if (obj.VALOR_ORIGINAL) {
        this.fluxo.VALOR_ORIGINAL = obj.VALOR_ORIGINAL;
      }
      if (obj.VALOR_PAGO) {
        this.fluxo.VALOR_PAGO = obj.VALOR_PAGO;
      }
      if (obj.LIQUIDACAO_TOTAL == "1") {
        this.fluxo.LIQUIDACAO_TOTAL = true;
      } else {
        this.fluxo.LIQUIDACAO_TOTAL = false;
        this.botoesMenu[5].exibir = true;
      }
      if (obj.DOCUMENTO_CODIGO_BARRAS) {
        this.fluxo.DOCUMENTO_CODIGO_BARRAS = obj.DOCUMENTO_CODIGO_BARRAS;
      }
      if (obj.DOCUMENTO_LINHA_DIGITAVEL) {
        this.fluxo.DOCUMENTO_LINHA_DIGITAVEL = obj.DOCUMENTO_LINHA_DIGITAVEL;
      }
      if (obj.DATA_EMISSAO) {
        this.fluxo.DATA_EMISSAO = moment(
          obj.DATA_EMISSAO,
          "YYYYMMDD[T]HHmmss"
        ).format("YYYY-MM-DD");
      }
      if (obj.EXERCICIO) {
        this.fluxo.EXERCICIO = obj.EXERCICIO;
      }
      if (obj.HISTORICO) {
        this.fluxo.HISTORICO = obj.HISTORICO;
      }
      if (obj.DOCUMENTO_TIPO) {
        this.fluxo.DOCUMENTO_TIPO = obj.DOCUMENTO_TIPO;
      }
      if (obj.OBSERVACAO) {
        this.fluxo.OBSERVACAO = obj.OBSERVACAO;
      }
      if (obj.ID_PROJETO) {
        this.fluxo.ID_PROJETO = obj.ID_PROJETO;
        this.$refs.projeto.selecionar({
          ID: obj.ID_PROJETO,
          DESCRICAO: obj.PROJETO
        });
      }
      if (obj.ID_PORTADOR) {
        this.fluxo.ID_PORTADOR = obj.ID_PORTADOR;
        this.$refs.portador.selecionar({
          ID: obj.ID_PORTADOR,
          DESCRICAO: obj.PORTADOR
        });
      }
      if (obj.ID_TIPO_DE_MULTA) {
        this.fluxo.ID_TIPO_DE_MULTA = obj.ID_TIPO_DE_MULTA;
        this.$refs.tipoMulta.selecionar({
          ID: obj.ID_TIPO_DE_MULTA,
          DESCRICAO: obj.TIPO_DE_MULTA
        });
      }
      if (obj.ID_NATUREZA_OPERACAO) {
        this.fluxo.ID_NATUREZA_OPERACAO = obj.ID_NATUREZA_OPERACAO;
        this.$refs.naturezaOperacao.selecionar({
          ID: obj.ID_NATUREZA_OPERACAO,
          DESCRICAO: obj.NATUREZA_OPERACAO
        });
      }
      if (obj.ID_CENTRO_RESPONSABILIDADE) {
        this.fluxo.ID_CENTRO_RESPONSABILIDADE = obj.ID_CENTRO_RESPONSABILIDADE;
        this.$refs.centroDeResponsabilidade.selecionar({
          ID: obj.ID_CENTRO_RESPONSABILIDADE,
          DESCRICAO: obj.CENTRO_RESPONSABILIDADE
        });
      }
      if (obj.USUARIO_INCLUSAO) {
        this.fluxo.USUARIO_INCLUSAO = obj.USUARIO_INCLUSAO;
      }
      if (obj.USUARIO) {
        this.fluxo.USUARIO = obj.USUARIO;
      }
      if (obj.DATA_INCLUSAO) {
        this.fluxo.DATA_INCLUSAO = moment(
          obj.DATA_INCLUSAO,
          "YYYYMMDD[T]HHmmss"
        ).format("YYYY-MM-DD HH:mm:ss");
      }
      if (obj.DATA_ALTERACAO) {
        this.fluxo.DATA_ALTERACAO = moment(
          obj.DATA_ALTERACAO,
          "YYYYMMDD[T]HHmmss"
        ).format("YYYY-MM-DD HH:mm:ss");
      }

      this.$nextTick(() => {
        this.formataValores();
      });
    },
    validarObjTitulo(obj) {
      let retorno = "";

      if (!obj.ID_EMPRESA || obj.ID_EMPRESA == "0") {
        retorno = "Empresa é um campo obrigatório.";
      } else if (!obj.DATA_EMISSAO) {
        retorno = "Data de emissão é um campo obrigatório.";
      } else if (!obj.DATA_VENCIMENTO) {
        retorno = "Data de vencimento é um campo obrigatório.";
      } else if (!obj.VALOR) {
        retorno = "Valor é um campo obrigatório.";
      } else if (!obj.VALOR_ORIGINAL) {
        retorno = "Valor Original é um campo obrigatório.";
      } else if (!obj.ID_EMITENTE || obj.ID_EMITENTE == "0") {
        retorno = "Emitente é um campo obrigatório.";
      } else if (!obj.ID_PLANO_FINANCEIRO || obj.ID_PLANO_FINANCEIRO == "0") {
        retorno = "Plano Financeiro é um campo obrigatório.";
      }

      return retorno;
    },
    limparForm() {
      Object.keys(this.fluxoVazio).forEach((item) => this.fluxo[item] = this.fluxoVazio[item]);

      this.$refs.emitente.apagar();
      this.$refs.planoFinanceiro.apagar();
      this.$refs.projeto.apagar();
      this.$refs.portador.apagar();
      this.$refs.tipoMulta.apagar();
      this.$refs.naturezaOperacao.apagar();
      this.$refs.centroDeResponsabilidade.apagar();

      this.fluxoDetalhadoGEDs = [];
    },
    async salvar(tipo) {
      let obj = {};
      Object.keys(this.fluxoVazio).forEach((item) => obj[item] = this.fluxo[item]);
      obj.RECORRENCIA = this.tituloRecorrente;
      obj.TRANSACAO = this.transacao;

      let retorno = this.validarObjTitulo(obj);

      if (retorno) {
        Swal.fire({
          title: "Aviso",
          text: retorno,
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      } else {
        this.loading = true;
        let retornoObj = await this.updateFluxoDeCaixa(obj);
        if (retornoObj.USUARIO_INCLUSAO) {
          this.fluxo.USUARIO_INCLUSAO = retornoObj.USUARIO_INCLUSAO;
        }
        if (retornoObj.USUARIO) {
          this.fluxo.USUARIO = retornoObj.USUARIO;
        }
        if (retornoObj.DATA_INCLUSAO) {
          this.fluxo.DATA_INCLUSAO = retornoObj.DATA_INCLUSAO;
        }
        if (retornoObj.DATA_ALTERACAO) {
          this.fluxo.DATA_ALTERACAO = retornoObj.DATA_ALTERACAO;
        }
        this.loading = false;

        Swal.fire({
          title: "Aviso",
          text: "Título salvo com sucesso.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });

        if (tipo === 0) {
          this.$router.push({ path: "/dashboard" });
        } else if (tipo === 1) {
          this.$router.push({ path: "/alterar-venda/" + retornoObj.ID_FLUXO_DE_CAIXA });
        } else if (tipo === 2) {
          this.limparForm();
          this.$router.push({ path: "/incluir-venda" });
        }
      }
    },
    voltar() {
      this.limparForm();

      this.$router.push({ path: "/dashboard" });
    },
    async buscarTelefonesEmitente() {
      this.telefones = [];
      this.loadingTelefones = true;
      this.telefones = await this.getEmitenteTelefone(this.fluxo.ID_EMITENTE);
      this.loadingTelefones = false;
    },
    async buscarBoletosFluxo() {
      this.boletos = [];
      this.loadingBoletos = true;
      this.boletos = await this.getBoletosFluxo(this.$route.params.id);
      this.loadingBoletos = false;
    },
    async buscarNFsFluxo() {
      this.nfs = [];
      this.loadingNFs = true;
      this.nfs = await this.getNFsFluxo(this.$route.params.id);
      this.loadingNFs = false;
    },
    efetuarRateio() {
      this.$refs.rateio.show();
    },
    quitar(){
      this.$refs.quitacao.show();     
    },
    clickMenu(opcao) {
      if(opcao == 'enviarEmailCobranca' || opcao == 'enviarSMSCobranca' || opcao == 'enviarWhatsAppCobranca') {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => this.$refs.botoesEnvio[opcao](), 1000);
      } else {
        this[opcao]();
      }
    },
    async saiuModal() {
      let rateios = await this.getRateios(this.$route.params.id);

      if(rateios.length) {
        this.temRateios = true;
      } else {
        this.temRateios = false;
      }
    },
    realizarBackupInformacoes() {
      let obj = {};
      
      Object.keys(this.fluxo).forEach((item) => obj[item] = this.fluxo[item]);

      if(obj.ID_EMITENTE) {
        let item = this.$refs.emitente.obterItem();
        obj.EMITENTE = item.DESCRICAO;
      }

      if (obj.ID_PLANO_FINANCEIRO) {
        let item = this.$refs.planoFinanceiro.obterItem();
        obj.PLANO_FINANCEIRO = item.DESCRICAO;
      }

      if (obj.ID_EMPRESA) {
        let item = this.$refs.empresa.obterItem();
        obj.EMPRESA = item.DESCRICAO;
      }

      if (obj.ID_PROJETO) {
        let item = this.$refs.projeto.obterItem();
        obj.PROJETO = item.DESCRICAO;
      }

      if (obj.ID_PORTADOR) {
        let item = this.$refs.portador.obterItem();
        obj.PORTADOR = item.DESCRICAO;
      }

      if (obj.ID_TIPO_DE_MULTA) {
        let item = this.$refs.tipoMulta.obterItem();
        obj.TIPO_DE_MULTA = item.DESCRICAO;
      }

      if (obj.ID_NATUREZA_OPERACAO) {
        let item = this.$refs.naturezaOperacao.obterItem();
        obj.NATUREZA_OPERACAO = item.DESCRICAO;
      }

      if (obj.ID_CENTRO_RESPONSABILIDADE) {
        let item = this.$refs.centroDeResponsabilidade.obterItem();
        obj.CENTRO_RESPONSABILIDADE = item.DESCRICAO;
      }
      
      this.atualizarFluxoInclusaoAlteracaoBackup(obj);
    },
    incluirEmitente() {
      this.realizarBackupInformacoes();
      
      this.$router.push({
        path: "/cadastros/emitente"
      });
    },
    alterarEmitente() {
      this.realizarBackupInformacoes();

      this.$router.push({
        path: "/cadastros/emitente/" + this.selected.ID
      });
    }
  }
};
</script>
